import UserSelector from "../../../../components/selectors/UserSelector";

interface StudentSelectorProps {
  selectedStudent: string | null;
  onStudentChange: (studentId: string | null) => void;
  placeholder?: string;
  inline?: boolean;
}

export default function StudentSelector({
  selectedStudent,
  onStudentChange,
  placeholder = "Öğrenci seçin...",
  inline = false,
}: StudentSelectorProps) {
  const handleUserChange = (userId: string) => {
    onStudentChange(userId || null);
  };

  return (
    <UserSelector
      value={selectedStudent}
      onChange={handleUserChange}
      placeholder={placeholder}
      allowClear={true}
      required={false}
      className="w-full"
      inline={inline}
    />
  );
}
